// Block Illegal invocations errors triggered by Facebook bots. Facebook bots
// do not present themselves in user-agents so we've to manually check for
// the specific error and a fbclid parameter in the URL.
const illegalInvocationFilter = (exception) => {
  const hasFbclid = window.location.href.indexOf('fbclid=') >= 0;

  return (
    exception.type !== 'TypeError'
    || exception.value.indexOf('Illegal invocation') < 0
    || !hasFbclid
  );
};

const filters = [
  illegalInvocationFilter,
];

export default (event) => {
  if (
    typeof window === 'undefined'
    || typeof window.location === 'undefined'
    || typeof event.exception === 'undefined'
    || typeof event.exception.values === 'undefined'
    || event.exception.values.length <= 0
  ) {
    return event;
  }

  const [exception] = event.exception.values;

  for (let i = 0; i < filters.length; i += 1) {
    if (!filters[i](exception)) {
      return null;
    }
  }

  return event;
};
